import { useEffect, useRef, useState } from 'react';
import { useIsomorphicLayoutEffect } from './useIsomorphicLayoutEffect';
const usePromise = (operation) => {
    const savedOperation = useRef(operation);
    useIsomorphicLayoutEffect(() => {
        savedOperation.current = operation;
    }, [operation]);
    const [state, setState] = useState({ data: undefined, state: 'pending', error: undefined });
    useEffect(() => {
        savedOperation.current()
            .then((data) => {
            setState(() => ({ data, state: 'success', error: undefined }));
        })
            .catch((error) => {
            setState(() => ({ data: undefined, state: 'failed', error }));
        });
    }, [savedOperation]);
    return state;
};
export default usePromise;
//# sourceMappingURL=usePromise.js.map